export default ({ Titulo, Subtitulo, Descripcion, Metadata }) => ({
    title: Titulo,
    subtitle: Subtitulo,
    description: Descripcion,
    metadata: Metadata
});